import { render, staticRenderFns } from "./NfceDetalheModal.vue?vue&type=template&id=b4b1e29c&scoped=true"
import script from "./NfceDetalheModal.vue?vue&type=script&lang=js"
export * from "./NfceDetalheModal.vue?vue&type=script&lang=js"
import style0 from "./NfceDetalheModal.vue?vue&type=style&index=0&id=b4b1e29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b1e29c",
  null
  
)

export default component.exports